import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Ref } from 'semantic-ui-react';
import { MENU_DIRECTION_LEFT, resolveMenuDirection } from '../helpers/actionMenuPlacement';

const ActionMenu = ({
  options, onChange, disabled, 'data-testid': dataTestId,
}) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [direction, setDirection] = useState(MENU_DIRECTION_LEFT);

  useLayoutEffect(() => {
    if (!isOpen || !dropdownRef.current) return;

    const menu = dropdownRef.current.querySelector('.menu.visible');
    if (!menu) return;

    const trigger = dropdownRef.current.getBoundingClientRect();

    setDirection(resolveMenuDirection({
      triggerLeft: trigger.left,
      triggerRight: trigger.right,
      menuWidth: menu.getBoundingClientRect().width,
      viewportWidth: document.documentElement.clientWidth,
    }));
  }, [isOpen]);

  return (
    <Ref innerRef={dropdownRef}>
      <Dropdown
        text='Actions'
        icon='ellipsis horizontal'
        options={options}
        onChange={onChange}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        direction={direction}
        disabled={disabled}
        data-testid={dataTestId}
        inline
        item
        selectOnBlur={false}
        value={null}
      />
    </Ref>
  );
};

ActionMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      disabled: PropTypes.bool,
      description: PropTypes.string,
      'data-testid': PropTypes.string,
    })
  ),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  'data-testid': PropTypes.string,
};

ActionMenu.defaultProps = {
  options: [],
  disabled: false,
  'data-testid': undefined,
};

export default ActionMenu;
